import React from 'react';
import { useDataFetcher } from '../../../hooks';
import { Container } from 'react-bootstrap';
import { FormHeading, Well } from '../../../form';
import { RouteButton } from '../../../form/routeButton';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import { VisitorTypeList } from './VisitorTypeList';

export const VisitorTypeListPage: React.FC = () => {
  const { busy, errors, data } = useDataFetcher('/api/visitorTypes');

  const visitorTypes = data?.visitorTypes || [];

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Visitor Types" subTitle="List" backPath="/admin" />
        <RouteButton className="mb-2" to="/admin/visitorTypes/create">
          Create a new visitor type
        </RouteButton>
        <AjaxErrorBoundary
          busy={busy}
          loadingText="Loading visitor types"
          errors={errors}
        >
          <VisitorTypeList visitorTypes={visitorTypes} />
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
